<template>
  <nav-item
    v-if="canUseAIChat"
    class="ai-chat-nav-item"
    :title="$t('aiChat.title')"
    icon="message"
    :active="active"
    hover-color="beige"
    @click="onClick"
  />
</template>

<script setup>
import NavItem from '@/components/navigation/NavItem.vue';
import useAIChat from '@/composables/ai-chat/ai-chat';
import useAiChatPanel from '@/composables/ai-chat/ai-chat-panel';
import { AI_CHAT } from '@/route-names';
import { computed } from 'vue';
import { fullScreenRoute } from '@/lib/ai-chat-route';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

const store = useStore();
const route = useRoute();
const router = useRouter();
const { canUseAIChat } = useAIChat();
const { open, activeChatId, toggle } = useAiChatPanel();

const smAndDown = computed(() => store.state.breakpoint.smAndDown);
const active = computed(() => (open.value && !smAndDown.value) || route.name === AI_CHAT);

const onClick = () => {
  if (smAndDown.value) {
    router.push(fullScreenRoute(activeChatId.value));
    return;
  }
  toggle();
};
</script>
